import { SxProps } from '@mui/material'

import { FONT_WEIGHTS } from '@/styles'

import { navigationDrawerClasses } from '..'

interface ItemListStyles {
  container: SxProps
  listItem: SxProps
  itemName: SxProps
}

export const itemListStyles: ItemListStyles = {
  container: {
    px: 1.5,
    py: 1,
    mx: 1.5,
    my: 0.2,
    backgroundColor: 'background.default',
    borderRadius: 3,
    borderColor: 'border.secondary',
    borderWidth: 1,
    borderStyle: 'solid',
    boxShadow: '0 1px 2px 0 rgba(10, 13, 18, 0.05)',
  },
  listItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 2,
    cursor: 'pointer',
    overflow: 'hidden',
    justifyContent: 'space-between',
    px: 2,
    py: 1.5,

    [`.${navigationDrawerClasses.chevronRightIcon}`]: {
      width: 24,
      height: 24,
      color: 'brand.primary600',
    },
  },
  itemName: {
    typography: 'textMdSemibold',
    textTransform: 'capitalize',
    color: 'text.primary900',
  },
}

interface ChildrenItemListStyles {
  container: SxProps
  header: SxProps
  selectedItemName: SxProps
  childrenItem: SxProps
  colorBar: SxProps
  childrenItemName: SxProps
}

export const childrenItemListStyles: ChildrenItemListStyles = {
  container: {
    overflow: 'auto',
    height: 'auto',
    transition: 'max-height 0.4s ease, opacity 0.3s ease',
    borderRadius: 3,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'border.secondary',
    boxShadow: '0 1px 2px 0  rgba(10, 13, 18, 0.05)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    cursor: 'pointer',
    mt: 1,
    py: 1,
    px: 2,

    [`.${navigationDrawerClasses.chevronLeftIcon}`]: {
      color: 'brand.primary600',
      width: 20,
      height: 20,
    },
  },
  selectedItemName: {
    typography: 'textSm',
    fontWeight: FONT_WEIGHTS.STRONG,
    textTransform: 'uppercase',
    color: 'brand.primary600',
    fontStyle: 'normal',
  },
  childrenItem: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 2,
    cursor: 'pointer',
    overflow: 'hidden',
    py: 1.5,
    px: 2,
    gap: 1,
    mt: 0.25,
    textDecoration: 'none',
  },
  colorBar: {
    width: 5,
    height: 24,
    borderRadius: 1,
  },
  childrenItemName: {
    typography: 'textMdSemibold',
    textTransform: 'capitalize',
    color: 'text.primary900',
  },
}
